import React, { Component, Fragment } from 'react';
import _ from 'lodash'
import Addlink from '../Common/Addlink';
import { connect } from "react-redux";
import getRights from "../../redux/action/rights";
import { bindActionCreators } from "redux";
import "react-confirm-alert/src/react-confirm-alert.css"
class ListHeader extends Component {

    state = {

    }

    componentWillMount() {
        const { header, toggleFilter, link, type } = this.props
        let { action, _id, fabric } = this.state;        
        this.setState({
            header, toggleFilter, link, type
        })
        this.props.getRights(this.props.moduleName);
        let accessCriteria = this.props.rights !== undefined && this.props.selectedRight !== undefined && this.props.selectedRight.rightsName !== undefined && _.get(this.props.rights, this.props.selectedRight.rightsName.toString());
        this.setState({
            accessCriteria
        })
    }

    componentWillReceiveProps(nextProps) {
        const { header, toggleFilter, link, type } = nextProps
        let accessCriteria = nextProps.rights !== undefined && nextProps.selectedRight !== undefined && _.get(nextProps.rights, nextProps.selectedRight.rightsName.toString());        
        this.setState({
            header, toggleFilter, link, type, accessCriteria
        })
    }

    comparePage = data => {
        let action = (this.props.rights.costing.web.edit && "edit") || (this.props.rights.costing.web.view && "view");
        let search = "?" + new URLSearchParams({
            _id: data.map(x => x._id).join(',')

        }).toString()
        window.open(`/CostingComparison${search}`, "_blank")
    }
    render() {

        const { onToggleShow, history, costingCompare, clearCompare } = this.props
        const { header, toggleFilter, link, type, accessCriteria } = this.state
        return (
            <div className="col-md-12 nopadding mt-1 position-top-stick ">
                <div class="col-md-4">
                    {/* onClick={() => onToggleShow()} <i className={toggleFilter ? "fa fa-angle-up" : "fa fa-angle-down"}></i> */}
                    <span>Filters</span>
                </div>
                <div class="col-md-4 text-center">
                    <h6>{header}</h6>
                </div>
                <div class="col-md-4 ">

                    {((accessCriteria !== undefined && accessCriteria.web !== undefined && accessCriteria.web.create && type == 'list')) && <Addlink
                        link={link}
                        history={history}
                    />}
                    {type == 'report' &&
                        <button class="primary pull-right"><i className="material-icons">publish</i> export report</button>
                    }
                    {/* change to COSTING */}
                    {header === "Costing" && <div className="holderFilter">
                        {costingCompare && costingCompare.length > 0 && costingCompare.map((x, i) => <span className="px-1">{`${x.costingNumber}${costingCompare.length !== (i + 1) && ',' || ''}`}</span>)}
                        <div>
                            <a
                                href="javascript:;"
                                // href={'/CostingComparison'}
                                className="primary"
                                // target="_blank"
                                style={{ fontSize: "8px" }}
                                onClick={
                                    () => {
                                        if (costingCompare.length > 1) {
                                            this.comparePage(costingCompare)
                                        }
                                        else {
                                            this.props.getalertMessage('error', 'Please select an another value to Compare')
                                        }
                                    }
                                }
                            >Compare</a>
                            <a href="javascript:;"
                                style={{ fontSize: "8px" }}
                                className="primary"
                                onClick={() => clearCompare()}
                            >Clear</a>
                        </div>
                    </div>}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        rights: state.main.rights,
        selectedRight: state.rights.rightsInfo
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        "getRights": getRights
    }, dispatch)
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(ListHeader);




// WEBPACK FOOTER //
// ./src/components/ListPage/ListHeader.js